import styled from 'styled-components';
import { sizes } from 'style';
import Button from 'products/nomad_insurance/components/Button';
import { th } from 'style/theme';

export const ClaimInfos = styled.div`
  font-size: 16px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  row-gap: 12px;

  @media ${sizes.tabletLandscape} {
    display: flex;
    justify-content: space-between;
  }
`;

export const NoteHeading = styled.h4`
  margin: 0;
  margin-bottom: 12px;
  font-size: 20px;
  line-height: 28px;
`;

export const Note = styled.div`
  font-size: 16px;
  line-height: 24px;
  padding: 24px;
  border: 1px solid ${th('colors.porsche')};
  border-radius: 24px;
  white-space: pre-line;
  background-color: ${th('colors.porsche+4')};

  @media ${sizes.tabletPortrait} {
    min-width: 350px;
    margin-top: 0px;
  }
`;

export const DoneButton = styled(Button)`
  margin-top: 16px;

  @media ${sizes.tabletPortrait} {
    align-self: flex-end;
  }
`;
